// extracted by mini-css-extract-plugin
export var statItem = "_i9-1";
export var statsRow = "_i9-0";